<template>
    <div class="form">
        <div class="row">
            <label class="label-title">服务名</label>
            <div
                class="input-like"
                contenteditable="false"
                placeholder="mcp-server-template"
                id="servername"
            >
                {{ formInput.formData.mcpServeName }}
            </div>
            <button class="button-copy" @click="handleClick('servername')">
                复制
            </button>
        </div>
        <div class="row">
            <label class="label-title">服务URL</label>
            <div
                class="input-like"
                contenteditable="false"
                placeholder=""
                id="serverurl"
            >
                {{
                    `${baseurl}/mcp/${formInput.formData.mcpServeName}-${formInput.formData.comVersion}`
                }}
            </div>
            <button class="button-copy" @click="handleClick('serverurl')">
                复制
            </button>
        </div>
    </div>
</template>

<script setup>
import {
    ref,
    onMounted,
    getCurrentInstance,
    defineExpose,
    defineProps,
    reactive,
} from "vue";

import Qs from "qs";
import { VXETable } from "vxe-table";

const { proxy } = getCurrentInstance();
const props = defineProps({
    appId: {
        // 查询类型
        type: String,
        default: "",
    },
});
const baseurl = ref("http://172.26.93.128:3000"); //测试地址

const formInput = reactive({
    formData: {
        Id: "",
        status: "0",
        appName: "名称",
        appDesc: "",
        appIcon: "",
        mcpServeName: "",
        isRemote: "",
        creatorUID: "",
        CreateMan: "",
        creationTime: "",
        appClassId: "",
        labelId: "",
        fPathPackage: "",
    },
});

const loadData = (appId) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [appId],
    };
    proxy.$api.componentManageAPI
        .getComponentOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData = res.data.Data;
        })
        .catch((error) => {
            console.log(error);
        });
};
const getBaseUrl = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: "",
        pageSize: "",
        searchKey: ["30", "4"],
    };
    proxy.$api.systemManageAPI
        .getLookupValue(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            baseurl.value = res.data.Data.LookupValueName;
        })
        .catch((error) => {
            console.log(error);
        });
};
function handleClick(id) {
    const text = document.getElementById(id).innerText.trim();
    if (!text) {
        VXETable.modal.message({
            content: "没有内容可复制！",
            status: "error",
        });
        return;
    }

    // 优先使用 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                VXETable.modal.message({
                    content: "已复制: " + text,
                    status: "success",
                });
            })
            .catch((err) => {
                console.error("复制失败: ", err);
            });
    } else {
        // 兼容旧浏览器（回退方案）
        const temp = document.createElement("textarea");
        temp.value = text;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
        VXETable.modal.message({
            content: "已复制: " + text,
            status: "success",
        });
    }
}
onMounted(() => {
    loadData(props.appId);
    getBaseUrl();
});
</script>

<style scoped>
.form {
    display: flex;
    flex-direction: column;
    gap: 20px; /* 每一行之间固定 20px 间距 */
    max-width: 700px;
    margin: 10px 10px;
    padding: 10px;
    border-radius: 16px;
}

.row {
    display: flex;
    align-items: center;
    justify-content: flex-start; /* 左对齐 */
    gap: 12px;
    margin-bottom: 20px;
    margin-top: 10px;
}

.label-title {
    width: 80px;
    font-weight: 600;
    color: #374151;
}

.input-like {
    flex: 1;
    padding: 6px 0;
    border: none;
    border-bottom: 2px solid #d1d5db;
    outline: none;
    background: transparent;
    min-height: 24px;
    line-height: 1.5;
    transition: border-color 0.2s;
    width: 400px;
}
.input-like:focus {
    border-bottom-color: #3b82f6;
}

/* 模拟 placeholder */
.input-like:empty:before {
    content: attr(placeholder);
    color: #9ca3af;
}
.input-like:focus:before {
    content: "";
}

.button-copy {
    padding: 8px 16px;
    background: #3b82f6;
    border: none;
    border-radius: 8px;
    color: white;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
}
.button-copy:hover {
    background: #2563eb;
}
.button-copy:active {
    transform: translateY(1px);
}
</style>
